import React, { useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { ModalChiTietHopDong } from "./ModalChiTietHopDong";
// import { ModalGiaHan } from "./ModalGiaHan";

export const BtnChiTietHopDong = ({ item }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      {typeof item.MaNhanVay !== "undefined" && (
        <a href={() => false} className="color-xanh-bold" onClick={handleShow}>
          {item.MaNhanVay}
        </a>
      )}
      {typeof item.MaNhanVay === "undefined" && (
        <a href={() => false} className="color-xanh-bold" onClick={handleShow}>
          {item.Code}
        </a>
      )}
      {show && typeof item.ID  !==  "undefined" && (
        <ModalChiTietHopDong
          show={show}
          onHide={handleClose}
          nhanvayId={item.ID}
          item={item}
        />
      )}
      {show && typeof item.NhanVayId  !==  "undefined" && (
        <ModalChiTietHopDong
          show={show}
          onHide={handleClose}
          nhanvayId={item.NhanVayId}
          item={item}
        />
      )}
    </>
  );
};
